import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import Loading from "../../Components/Loading";

import {
  SubmitBtn,
  OtherBtn,
  CancelBtn
} from "../Styles/InputStyles";
import { useTranslation } from "react-i18next";

const AnnualFeeModal = ({ setAnnualFeesModel, selectedItem, serviceType, apiData, generateCNoMutate, GenerateCNoLoading}) => {
  //console.log("apiData", apiData);

  const { t, i18n } = useTranslation();
  const getStatus = (status) => {
    if (status == 0) {
      return <>Annual Fees Due</>;
    }
    if (status == 1) {
      return <>Paid</>;
    }if (status == 2) {
      return <>C. No available, Please proceed to pay</>;
    } 
    
  };
  return (
    <Model width={"w-8/12 max-w-lg"} setOpenModel={setAnnualFeesModel}>
      <Wrapper>
        <Title>{t("MakeAnnualFees")}</Title>

        <SingleItem name={"Status"} value={getStatus(apiData.annualFeesStatus) } />
        <SingleItem name={"Annual Fees"} value={apiData.amount || "700" + " TZS"} />
        <SingleItem name={"Association Made On"} value={apiData.assocCertifyDate } />
        <SingleItem name={"Last Payment"} value={apiData.previosPaymentDate || selectedItem.date} />
        <SingleItem name={"Payment Due On"} value={apiData.paymentDuedate || selectedItem.date} />
        {/* <SingleItem name={"Control Number"} value={selectedItem.annualFeesControlNumber || "Not Generated"} />
        <SingleItem name={"Control No. Exp Date"} value={selectedItem.annualFeesControlNumberExpDate || "NA"} /> */}


        
      </Wrapper>
      {GenerateCNoLoading && <Loading />}
      {(apiData.annualFeesStatus!=1) && (!GenerateCNoLoading) && <BtnWrapper>
          <SubmitBtn onClick={() => generateCNoMutate(selectedItem)}>{t("GenerateControlNo")}</SubmitBtn>
      </BtnWrapper>}
    </Model>
  );
};

const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <Name>{name}</Name> <p className="w-10">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;
const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;
const BtnWrapper = tw.div` w-full flex items-center justify-end space-x-10 mt-8`;

export default AnnualFeeModal;
